<template>
  <div class="headerBox" :class="{whiteBack:colorType==3,headerOrangeBack:colorType==1,headerBlackBack:colorType==2}">
    <div class="headerBanner">
      <div class="logobox">
        <img src="../../assets/header/blackLogo.png" v-show="colorType==1" class="companyLogo" />
        <img src="../../assets/header/whiteLogo.png" v-show="colorType==2" class="companyLogo" />
        <img src="../../assets/header/greenLogo.png" v-show="colorType==3" class="companyLogo" />
        <span :style="{color:colorType==1?'#111':colorType==2?'#fff':'#0d701d'}">任马停共享停车服务平台</span>
      </div>
      <ul class="routerBox">
        <li class="routerList" :class="{active: pageType=='home'&&(colorType=='1'||colorType=='3'),blackActive: pageType=='home'&&colorType=='2'}">
          <router-link class='routerLink' :class="{blackList:colorType=='2'}" to='/' exact>首页</router-link>
        </li>
        <li class="routerList" :class="{active: pageType=='plan'}">
          <router-link class='routerLink' :class="{blackList:colorType=='2'}" to='/plan'>方案</router-link>
        </li>
        <li class="routerList productLink" :class="{active: pageType=='product'}">
          <div class='routerLink' :class="{blackList:colorType=='2'}">
                      产品
            <img src="../../assets/header/down.png" class="productDown" v-show="colorType=='1'||colorType=='3'" />
            <img src="../../assets/header/whiteDown.png" class="productDown" v-show="colorType=='2'"/>
          </div>
          <div class="productSelectTotal">
            <ul class="productSelectBox">
              <router-link class='routerSecondLink' :class="{blackList:colorType=='2'}" to='/Productcenter'>
                <li class="productSelectList" :class="{productActive:productType==1}">
                  <img src="../../assets/header/productCenter.png" class="productListIcon" alt="" />
                  <div class="productListName">产品中心</div>
                </li>
              </router-link>
              <router-link class='routerSecondLink' :class="{blackList:colorType=='2'}" to='/Productbest'>
                <li class="productSelectList" :class="{productActive:productType==2}">
                  <img src="../../assets/header/productBest.png" class="productListIcon" alt="" />
                  <div class="productListName">产品优势</div>
                </li>
              </router-link>
            </ul>
          </div>
        </li>
        <li class="routerList" :class="{active: pageType=='ck'}">
          <router-link class='routerLink' :class="{blackList:colorType=='2'}" to='/Ck'>创客</router-link>
        </li>
        <li class="routerList" :class="{active: pageType=='example'}">
          <router-link class='routerLink' :class="{blackList:colorType=='2'}" to='/Example'>案例</router-link>
        </li>
        <li class="routerList" :class="{active: pageType=='about'}">
          <router-link class='routerLink' :class="{blackList:colorType=='2'}" to='/About'>关于</router-link>
        </li>
      </ul>
      <div class="phoneBox" :class="{blackBorder:colorType=='2'}">
        <img src="../../assets/header/blackPhone.png" class="phoneIcon" v-show="colorType==1||colorType==3"/>
        <img src="../../assets/header/whitePhone.png" class="phoneIcon" v-show="colorType==2"/>
        <div class="phoneNumber" :class="{blackList:colorType=='2'}">400-1518-788</div>
      </div>
    </div>
  </div>
</template>
<!--colorType=1：橙色；colorType=2：黑色；colorType=3：白色-->
<script>
export default{
  name: 'Header',
  data: function () {
    return {
      name: 'we'
    }
  },
  props: ['logoUrl', 'colorType', 'pageType', 'productType']
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
}
.headerBox{
  width: 100%;
}
.whiteBack{
  background-color: #fff;
  box-shadow:0px 0px 10px -0px #efefef;
}
.headerOrangeBack{
  background-color: RGBA(255, 182, 30, 1);
}
.headerBlackBack{
  background-color: RGBA(61, 59, 79, 1);
}
.headerBanner{
  width: 1200px;
  height: 120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logobox{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logobox span{
  /* font-size:15px; */
  margin-top: 3px;
}
.companyLogo{
  width: 69px;
  /* height: 88px; */
}
.routerBox{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 554px;
  position: relative;
}
.routerList{
  width:80px;
  height:34px;
  border-radius:17px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.routerList>img{
  width: 10px;
  margin-left: 5px;
}
.routerLink{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  color:rgba(35,24,21,1);
}
.routerSecondLink{
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  color:rgba(35,24,21,1);
}
.phoneBox{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  width:190px;
  height:36px;
  border:2px solid rgba(35,24,21,1);
  border-radius:10px;
}
.phoneIcon{
  width:22px;
  height:18px;
}
.phoneNumber{
  color:rgba(35,24,21,1);
  margin-left: 10px;
}
.active{
  background-color: RGBA(255, 219, 143, 1);
}
.blackActive{
  background-color: RGBA(158, 157, 167, 1);
  color: RGBA(35, 24, 21, 1);
}
.blackList{
  color: RGBA(255, 255, 255, 1);
}
.blackBorder{
  border-color: RGBA(255, 255, 255, 1);
}
.productDown{
  margin-left: 5px;
}
.productSelectTotal{
  position: absolute;
  bottom: -190px;
  left: 110px;
  width:240px;
  height:200px;
  background:transparent;
  padding-top: 20px;
  display: none;
}
.productSelectBox{
  height: 180px;
  background:rgba(255,255,255,1);
  box-shadow:0px 4px 20px 0px rgba(204,204,204,0.5);
  padding: 10px 15px;
}
.productLink:hover .productSelectTotal{
  display: block;
}
.productSelectList{
  width: 210px;
  height: 70px;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 15px;
  cursor: pointer;
}
.productListIcon{
  width: 50px;
  height: 50px;
  margin-right: 21px;
}
.productListName{
  font-size:18px;
  font-weight:400;
  color:rgba(0,0,0,1);
}
.productActive{
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px 0px rgba(214,214,214,0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue